import React from "react";

import { Box, Button, useBoolean } from "@chakra-ui/react";

import useTranslations from "../../../../hooks/useTranslations";

import {
  QuestionFragment,
  ReportFragment,
} from "../../../../graphql/generated/definitions";

import AnswerHistory from "../answers/AnswerHistory";

const QuestionHistory: React.FC<{
  question: QuestionFragment;
  report: ReportFragment;
}> = (props) => {
  const t = useTranslations();
  const [open, { on, off }] = useBoolean(false);

  return (
    <Box>
      <Button
        size="sm"
        variant="outline"
        onClick={on}
        id={`answerHistoryButton-${props.question.id}`}
      >
        {t("reports.edit.answerHistory")}
      </Button>
      <AnswerHistory open={open} onClose={off} {...{ ...props }} />
    </Box>
  );
};

export default React.memo(QuestionHistory);
